import { Injectable } from '@angular/core';
import { SideDialogService } from '../../ecaps-core/side-dialog/side-dialog.service';
import {
  EventCategories,
  GoogleAnalyticsService,
} from '../../google/services/google-analytics.service';
import { ProjectInfoDialogData } from '../dialogs/project-info-dialog/models/project-info-dialog-data.model';
import { ProjectInfoDialogComponent } from '../dialogs/project-info-dialog/project-info-dialog.component';
import { ProjectSummary } from '../models/project-summary.model';
import { Project } from '../models/project.model';

@Injectable({
  providedIn: 'root',
})
export class ProjectInfoDialog {
  constructor(
    private sideDialogService: SideDialogService,
    private analytics: GoogleAnalyticsService
  ) {}

  show(
    summary: ProjectSummary,
    publicToken?: string,
    project?: Project
  ): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const dialogRef = this.sideDialogService.open(
        ProjectInfoDialogComponent,
        {
          disableClose: false,
          autoFocus: true,
          data: new ProjectInfoDialogData(summary, publicToken, project),
        }
      );

      const showSubscription = dialogRef.opened.subscribe(() => {
        showSubscription.unsubscribe();

        if (!!publicToken) {
          this.analytics.trackEvent_Old(
            EventCategories.sharing,
            'Shared Project Viewed',
            publicToken
          );
        }
      });

      const subscription = dialogRef.closed.subscribe((results) => {
        subscription.unsubscribe();

        resolve(!!results);
      });
    });
  }
}
